import { render, staticRenderFns } from "./IssueSeverityTableCell.vue?vue&type=template&id=1af360da&scoped=true"
import script from "./IssueSeverityTableCell.vue?vue&type=script&lang=js"
export * from "./IssueSeverityTableCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af360da",
  null
  
)

export default component.exports